var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCsvIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.0619 5.061V1.31375H4.86669C4.19394 1.31375 3.64844 1.8595 3.64844 2.53225V22.5953C3.64844 23.268 4.19394 23.8138 4.86669 23.8138H19.8094C20.4822 23.8138 21.0277 23.268 21.0277 22.5953V6.2795H17.2807C16.6079 6.2795 16.0619 5.734 16.0619 5.061Z",
    fill: "#0074B3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.0625 5.061C16.0625 5.73375 16.6085 6.2795 17.2812 6.2795H21.0282L16.0625 1.31375V5.061Z",
    fill: "#98C7E1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.6,
    d: "M16.0625 5.061C16.0625 5.73375 16.6085 6.2795 17.2812 6.2795H21.0282L16.0625 1.31375V5.061Z",
    fill: "#98C7E1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000001187"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.79611 14.7233C6.48601 14.7233 6.26953 14.9457 6.26953 15.2675C6.26953 15.5779 6.48601 15.8061 6.78441 15.8061H6.79026C7.10653 15.8061 7.31717 15.5779 7.31717 15.2675C7.31099 14.9398 7.10068 14.7233 6.79611 14.7233Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.95028 12.4642C10.2721 12.4642 10.524 12.5344 10.6995 12.6105L10.8867 11.9084C10.7288 11.8265 10.3777 11.7325 9.91517 11.7325C8.72126 11.7325 7.76172 12.4759 7.76172 13.8219C7.76172 14.9518 8.46383 15.806 9.82741 15.806C10.3013 15.806 10.6758 15.7124 10.8341 15.6364L10.7054 14.9343C10.5237 15.0103 10.2311 15.063 9.95613 15.063C9.16561 15.063 8.69786 14.5656 8.69786 13.7754C8.69786 12.8916 9.24752 12.4642 9.95028 12.4642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M13.0181 13.4007C12.5032 13.2017 12.2867 13.0906 12.2867 12.8387C12.2867 12.6397 12.4739 12.458 12.8601 12.458C13.2407 12.458 13.5274 12.5695 13.6795 12.6453L13.8785 11.9314C13.6444 11.8203 13.3223 11.7325 12.8718 11.7325C11.9467 11.7325 11.3792 12.2415 11.3792 12.9147C11.3792 13.4943 11.8121 13.857 12.4681 14.0911C12.942 14.2552 13.1292 14.4015 13.1292 14.6414C13.1292 14.905 12.9124 15.0743 12.5029 15.0743C12.1226 15.0743 11.7481 14.9515 11.5137 14.8286L11.332 15.56C11.5547 15.6832 11.9994 15.806 12.4499 15.806C13.5326 15.806 14.0358 15.244 14.0358 14.5829C14.0364 14.0212 13.7146 13.6581 13.0181 13.4007Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M16.547 13.4826C16.4124 13.9334 16.2892 14.4015 16.1897 14.8754H16.1722C16.0782 14.3836 15.9557 13.939 15.8211 13.465L15.341 11.7969H14.3633L15.6277 15.7417H16.6695L17.998 11.7969H17.0498L16.547 13.4826Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsvIcon);
export default __webpack_public_path__ + "static/media/csv-icon.5beb124ba882c44cc784ce20ebeb72a8.svg";
export { ForwardRef as ReactComponent };